import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { ListItemIconStyle } from './styles';
import { RcListItemIconClasses } from './utils';
var _RcListItemIcon = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcListItemIcon' });
    var classesProp = props.classes, children = props.children, color = props.color, rest = __rest(props, ["classes", "children", "color"]);
    var classes = useMemo(function () { return combineClasses(RcListItemIconClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiListItemIcon, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcListItemIcon = styled(_RcListItemIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ListItemIconStyle);
RcListItemIcon.defaultProps = {};
RcListItemIcon.displayName = 'RcListItemIcon';
export { RcListItemIcon };
var templateObject_1;
